import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 32 32'
    >
      <path d='M7 28c-1.6 0-3-1.4-3-3V7c0-1.6 1.4-3 3-3h18c1.6 0 3 1.4 3 3v18c0 1.6-1.4 3-3 3H7zm0-2h18c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1zm3-14v-2h12v2H10z'/>
    </svg>
  );
}

export default Icon;
